/**
 * URL звуковых файлов для веба. Пара к `themeSoundAssets.ts` (нативная заглушка) —
 * почему раскол, а не ветка по `Platform.OS`, написано там.
 *
 * Ключ — то же имя файла, что возвращают `*IosFilename()` в `themeSounds.ts`.
 * webpack (`resolve.extensions`) берёт этот файл раньше `.ts`, Metro — наоборот.
 */

function url(mod: unknown): string {
  return (mod as string) || '';
}

export const SOUND_ASSET_URLS: Readonly<Record<string, string>> = {
  'message_sword.wav': url(require('../../assets/sounds/message_sword.wav')),
  'message_dark.wav': url(require('../../assets/sounds/message_dark.wav')),
  'message_neutral.wav': url(require('../../assets/sounds/message_neutral.wav')),
  'ring_horn.wav': url(require('../../assets/sounds/ring_horn.wav')),
  'ring_dark.wav': url(require('../../assets/sounds/ring_dark.wav')),
  'ring_neutral.wav': url(require('../../assets/sounds/ring_neutral.wav')),
  'outgoing_ringback.mp3': url(require('../../assets/sounds/outgoing_ringback.mp3')),
  'outgoing_ringback_dark.wav': url(require('../../assets/sounds/outgoing_ringback_dark.wav')),
  'outgoing_ringback_neutral.wav': url(
    require('../../assets/sounds/outgoing_ringback_neutral.wav'),
  ),
  'tone_answer.wav': url(require('../../assets/sounds/tone_answer.wav')),
  'tone_end.wav': url(require('../../assets/sounds/tone_end.wav')),
};
